export default __webpack_public_path__ + "locales/ru/Payments.json?hash=a4bf2ddb2281cacde1e45195d66b6dfd";